import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';

import ConflictWarningIcon, { conflictPropType } from './ConflictPopover';
import colors from '../../constants/Colors';

export const conflictsByIdPropType = PropTypes.objectOf(PropTypes.arrayOf(conflictPropType));

export const getConflictTextColor = (conflicts) => (
  conflicts?.length > 0 ? colors.ONTRACCR_ERROR : undefined
);

export function ConflictLabel({ label, conflicts }) {
  return (
    <>
      <span style={{ color: getConflictTextColor(conflicts) }}>
        {label}
      </span>
      <ConflictWarningIcon conflicts={conflicts} />
    </>
  );
}

ConflictLabel.propTypes = {
  label: PropTypes.node,
  conflicts: PropTypes.arrayOf(conflictPropType),
};

ConflictLabel.defaultProps = {
  label: null,
  conflicts: [],
};

/**
 * Builds an antd Select tagRender that highlights selected values with conflicts
 * @param {Object} conflictsById { [id]: conflict[] }
 * @returns {Function}
 */
export const useConflictTagRender = (conflictsById = {}) => useCallback(({
  label,
  value,
  closable,
  onClose,
}) => (
  <Tag closable={closable} onClose={onClose}>
    <ConflictLabel label={label} conflicts={conflictsById[value]} />
  </Tag>
), [conflictsById]);
